module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"page":"Page","of":"of","next":"Next","previous":"Previous"},"de":{"page":"Seite","of":"von","next":"Nächste","previous":"Vorherige"}}')
  delete Component.options._Ctor
}
